<template>
    <div>
        <rkm-area
            v-if="motivoAtendimento"
            title="Motivo do atendimento"
            no-margin-top
        >
            <span>{{ motivoAtendimento }}</span>
        </rkm-area>

        <rkm-area
            v-if="examesLaboratoriais.length > 0 || (showBoxIfEmpty && !motivoAtendimento)"
            title="Exames laboratoriais"
            no-margin-top
        >
            <rkm-table
                :fields="fields.tables.examesLaboratoriais"
                :items="examesLaboratoriais"
                hide-filters
                hide-pagination
            >
                <template v-slot:cell(procedimento.codigo)="{ value }">
                    {{ value | formatProcedimento }}
                </template>
            </rkm-table>
        </rkm-area>

        <rkm-area
            v-if="prescricoesInternas.length > 0 || (showBoxIfEmpty && !motivoAtendimento)"
            title="Medicamentos prescritos"
            no-margin-top
        >
            <rkm-list
                :items="prescricoesInternas"
                hide-filters
                hide-pagination
            >
                <template v-slot="{ item }">
                    <rkm-row>
                        <rkm-col>
                            <span>
                                <strong>{{ item.nome }}</strong>
                            </span>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <hr>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col
                            v-for="(aplicacao, i) in item.aplicacoes"
                            :key="i"
                            cols="3"
                        >
                            <span>
                                <strong>{{ aplicacao.numero }}ª Aplicacao:</strong> {{ aplicacao.status.nome }}
                            </span>
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-list>
        </rkm-area>

        <rkm-area
            v-if="servicosEnfermagem.length > 0 || (showBoxIfEmpty && !motivoAtendimento)"
            title="Serviços de enfermagem"
            no-margin-top
        >
            <rkm-table
                :fields="fields.tables.servicosEnfermagem"
                :items="servicosEnfermagem"
                hide-filters
                hide-pagination
            >
                <template v-slot:cell(procedimento.codigo)="{ value }">
                    {{ value | formatProcedimento }}
                </template>
            </rkm-table>
        </rkm-area>

        <rkm-area
            v-if="observacoesEnfermagem.length > 0 || (showBoxIfEmpty && !motivoAtendimento)"
            title="Observações de Serviços de Enfermagem"
            no-margin-top
        >
            <rkm-form-incremental-textarea
                :items="observacoesEnfermagem"
                readonly
            >
                <template v-slot:row="{ item }">
                    <rkm-row>
                        <rkm-col cols="4">
                            <div>Setor: {{ item.centroCusto.setor.nome }}</div>
                            <div>{{ item.lotacao.profissional.nome }}</div>
                            <div>Class. Risco: {{ item.classificacaoRisco.nome }}</div>
                            <div>{{ item.dataHora }}</div>
                        </rkm-col>

                        <rkm-col>
                            {{ item.descricao }}
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-form-incremental-textarea>
        </rkm-area>
    </div>
</template>

<script>
import RkmFormIncrementalTextarea from '@/components/pronto-atendimento/components/base/FormIncrementalTextarea'

import formats from '@/filters/formats'

export default {
    components: { RkmFormIncrementalTextarea },
    computed: {
        fields() {

            return {
                tables: {
                    examesLaboratoriais: [
                        { key: 'exame.nome', label: 'Exame' },
                        { key: 'procedimento.codigo', label: 'Código', class: 'col-min' },
                        { key: 'procedimento.nome', label: 'Procedimento' },
                        { key: 'status.nome', label: 'Status' },
                    ],
                    prescricoesInternas: [
                        { key: 'nome', label: 'Medicamento' },
                    ],
                    servicosEnfermagem: [
                        { key: 'procedimento.codigo', label: 'Código', class: 'col-min' },
                        { key: 'procedimento.nome', label: 'Nome' },
                        { key: 'status.nome', label: 'Status' },
                    ],
                }
            }
        }
    },
    filters: {
        ...formats,
    },
    props: {
        showBoxIfEmpty: { type: Boolean, default: false },
        motivoAtendimento: { type: String, default: '' },
        servicosEnfermagem: { type: Array, default: () => [] },
        observacoesEnfermagem: { type: Array, default: () => [] },
        prescricoesInternas: { type: Array, default: () => [] },
        examesLaboratoriais: { type: Array, default: () => [] },
    }
}
</script>